webix.protoUI({
	name:"kanbanchat",
	$init(config){
		config.padding = 0;

		this.$ready.push(function(){
			this.attachEvent("onHide", this._save);
		});
	},
	_save(){
		let context = this.getContext();
		let comments = this.getBody();
		let kanban = this.getKanban();

		if (context && kanban.exists(context.id))
			kanban.updateItem(context.id, {comments:comments.serialize()});

		comments.queryView({view:"form"}).clear();
		comments.queryView({view:"list"}).clearAll();
	},
	getKanban(){
		return webix.$$(this.config.masterId);
	}
}, webix.ui.context);
